import { render, staticRenderFns } from "./DocumentGenerator.vue?vue&type=template&id=4af49688&"
import script from "./DocumentGenerator.vue?vue&type=script&lang=js&"
export * from "./DocumentGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports